import { makeDestructurable as f, camelize as p } from "../../../../@vueuse_shared@13.1.0_vue@3.5.13_typescript@5.8.3_/node_modules/@vueuse/shared/index.js";
import { isDefined as C } from "../../../../@vueuse_shared@13.1.0_vue@3.5.13_typescript@5.8.3_/node_modules/@vueuse/shared/index.js";
import { shallowRef as d, defineComponent as i } from "vue";
function h(r = {}) {
  const {
    inheritAttrs: t = !0
  } = r, e = d(), l = /* @__PURE__ */ i({
    setup(u, { slots: o }) {
      return () => {
        e.value = o.default;
      };
    }
  }), s = /* @__PURE__ */ i({
    inheritAttrs: t,
    props: r.props,
    setup(u, { attrs: o, slots: c }) {
      return () => {
        var a;
        if (!e.value && process.env.NODE_ENV !== "production")
          throw new Error("[VueUse] Failed to find the definition of reusable template");
        const n = (a = e.value) == null ? void 0 : a.call(e, {
          ...r.props == null ? m(o) : u,
          $slots: c
        });
        return t && (n == null ? void 0 : n.length) === 1 ? n[0] : n;
      };
    }
  });
  return f(
    { define: l, reuse: s },
    [l, s]
  );
}
function m(r) {
  const t = {};
  for (const e in r)
    t[p(e)] = r[e];
  return t;
}
export {
  p as camelize,
  h as createReusableTemplate,
  C as isDefined,
  f as makeDestructurable
};
